import Vue from 'vue';

export default Vue.extend({
  name: 'Currency',

  props: {
    value: {
      type: Number,
      default: null,
    },
    // 単位切り替え用
    unit: {
      type: Number,
      default: null,
    },
  },

  computed: {
    cssClass(): string {
      return this.value !== null && this.value < 0 ? 'minus' : '';
    },
  },
});
